import React from 'react';
import { CheckIcon, FlameIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const bundle = [{
  emoji: '🤖',
  label: 'MakerLab — 100+ Robot Projects',
  value: '$47.00'
}, {
  emoji: '🎥',
  label: 'Bonus #1: Cardboard Arcade Pack',
  value: '$25.00'
}, {
  emoji: '✂️',
  label: 'Bonus #2: The 5-Minute Papercraft Guide',
  value: '$19.00'
}, {
  emoji: '🌈',
  label: 'Bonus #3: Little Creators: Slimes & Sensory Play',
  value: '$19.00'
}];
export function Offer() {
  return <section id="angebot" className="w-full bg-cream py-16 sm:py-24" data-id="element-120" data-mp="13xau77moxb42">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-121" data-mp="yy7qprmczcy7">
        <SectionHeading eyebrow="✦ Everything you get today" title={<>The complete MakerLab bundle</>} data-id="element-122" data-mp="ywd6ygmtpqvp" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-xl" data-id="element-123" data-mp="2ad3go9qgh0u2">
          <ul className="divide-y divide-ink/10" data-id="element-124" data-mp="pk7edh9xud7c">
            {bundle.map(item => <li key={item.label} className="flex items-center justify-between gap-4 px-6 py-4" data-id="element-125" data-mp="pml7hkl25fc9">
                <span className="flex items-center gap-3 text-sm font-semibold text-ink" data-id="element-126" data-mp="zjg6s5p5njrl">
                  <span className="text-xl" aria-hidden="true" data-id="element-127" data-mp="13k9twwurwujf">
                    {item.emoji}
                  </span>
                  {item.label}
                </span>
                <span className="flex-none text-sm font-medium text-ink/40 line-through" data-id="element-128" data-mp="bsu0ojypo9k8">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="space-y-2 bg-ink px-6 py-8 text-center text-white" data-id="element-129" data-mp="kl48xvq1q4yu">
            <p className="text-sm text-white/60" data-id="element-130" data-mp="kn8mz6hnskcu">
              Total value <span className="line-through" data-id="element-131" data-mp="3k7kr2t3jnmmf">$110.00</span>
            </p>
            <p className="flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-wide text-sunshine" data-id="element-132" data-mp="3o9pgffmylx39">
              <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="vepbh3odj7w8" />
              You pay today only
            </p>
            <p className="font-display text-5xl font-black" data-id="element-134" data-mp="qg4i9o7jhoha">$27.00</p>
            <p className="text-sm font-semibold text-emerald-400" data-id="element-135" data-mp="155tpa02bcmph">
              🎉 You save $83.00 today
            </p>

            <div className="pt-4" data-id="element-136" data-mp="107s7rjkjcvg4">
              <CtaButton href="https://curiousmindshub.shop/checkouts/cn/hWNEs6d8vfyA7OhwE8T3ajOE/en-ar?_r=AQABhE0uvG-ZpQIpOXUkamzF7C3Pv-83YvpPc-0IeBGcmpU" className="w-full sm:w-auto" data-id="element-137" data-mp="108tj7p5grjyd">
                Yes! I want it all for just $27
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-col items-center gap-2 text-sm text-white/70 sm:flex-row sm:justify-center sm:gap-6" data-id="element-138" data-mp="hfg5sxxsnw6i">
              {['Instant digital access', 'All 3 bonuses included', 'One-time payment, no subscription'].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-139" data-mp="20edzfas66fso">
                  <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-140" data-mp="25dqom26ijyyf" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink/50" data-id="element-141" data-mp="1vgc9c5wbtg7p">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="2j66l0k4wsyqd" />
          Instant access after purchase · 40,938+ downloads
        </p>
      </div>
    </section>;
}